import { PersonTypes } from "../../models";

const protectedPersonTypes: string[] = [PersonTypes.DoctorSurgeon];

export const isProtectedPersonType = (personType: string) => protectedPersonTypes.includes(personType);
